import { Tool } from '__generated__/api-types-and-hooks'
import React, { FC } from 'react'
import { AppTags, TagsText } from 'components/AppTools/AppToolsPanel/AppTags/AppTags.component'
import StarIcon from 'components/Common/SvgIcons/StartIcon'

interface IAppToolsLabelProps {
  tool: Tool
  isToolDisconnecting: boolean
}
export const AppToolsLabel: FC<IAppToolsLabelProps> = ({ tool, isToolDisconnecting }) => {
  return (
    <div className={`${isToolDisconnecting ? 'pt-0' : 'pt-7'}`}>
      <div className="flex items-center">
        <p className="text-lg text-primary-text leading-6 font-bold inline-flex pr-3">
          {tool.toolDisplayName ?? tool.toolName}
        </p>
        <div className="inline-flex flex-row gap-x-2">
          {tool.tags &&
            tool.tags.map((tag) => (
              <AppTags key={tag} tagText={tag} Icon={tag === TagsText.AI ? StarIcon : undefined}>
                {tag}
              </AppTags>
            ))}
        </div>
      </div>

      <p className="text-sm text-primary-text font-medium mt-2 mb-3 line-clamp-5">
        {tool.description || ''}
      </p>
    </div>
  )
}
